import { ReactElement, SyntheticEvent } from 'react';
import { VStack, Text, Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ContentType } from '@novaheal/types';
import { ProtectedRoutes } from 'types/Routes';
import { LikeButton } from '../atoms/LikeButton';
import {
  useIsInModal,
  useModalNavigation,
} from './Modal/variants/worksheet/components/ModalNavigationContext';

type MedicationCardProps = {
  id: string;
  name: string;
  indications: string;
  trademark: string[];
  afterLikeClickFn?: () => void;
  shouldShowWarning?: boolean;
  handleClick?: () => void;
  entryIsLiked?: boolean;
};

export const MedicationCard = ({
  id,
  name,
  indications,
  trademark,
  afterLikeClickFn,
  shouldShowWarning = false,
  handleClick,
  entryIsLiked,
}: MedicationCardProps): ReactElement => {
  const navigate = useNavigate();
  const isInModal = useIsInModal();
  const modalNavigation = useModalNavigation();

  const handleOuterClick = (e: SyntheticEvent<unknown, Event>): void => {
    e.stopPropagation();
    if (isInModal && modalNavigation) {
      modalNavigation.navigate({
        name: 'medication',
        params: { id },
      });
      return;
    }
    if (handleClick) {
      handleClick();
    }
    navigate(`${ProtectedRoutes.MEDICATION}/${id}`);
  };

  return (
    <Box
      onClick={handleOuterClick}
      cursor="pointer"
      px="10px"
      _hover={{ bg: 'background.canvas' }}
      _active={{ bg: 'background.canvas' }}
      id={id}
    >
      <VStack align="left" position="relative" gap="10px" p="20px 35px 15px 0px" pos="relative">
        <Box pos="absolute" bottom="15px" right="0">
          <LikeButton
            id={id}
            contentType={ContentType.MEDICATION}
            name={name}
            shouldShowWarning={shouldShowWarning}
            afterLikeClickFn={afterLikeClickFn}
            entryIsLiked={entryIsLiked}
          />
        </Box>
        <Text textStyle="body.m.regular">{name}</Text>
        <Text textStyle="body.s.regular" color="text.tertiary" lineClamp={2}>
          {indications}
        </Text>
        <Text textStyle="body.xs.regular" color="text.tertiary">
          {trademark.join(', ')}
        </Text>
      </VStack>
      <Box h="1px" width="100%" borderColor="border.accent" />
    </Box>
  );
};
